import React from 'react'
import { Navigate } from 'react-router-dom'
import { useMe } from '../../api/user'
import { Outlet } from 'react-router-dom'
import Navbar from '../../shared/Navbar'
import { Box, Container } from '@mui/material'
const AdminPrivateRoute = () => {
  const { data, isLoading } = useMe()

  if (isLoading) return <></>

  if (!data) return <Navigate to='/admin/login' />

  if (data.role !== 'admin') return <Navigate to='/user' />

  return (
    <Container component='main'>
      <Navbar user={data} />
      <Box marginTop={15}>
        <Outlet />
      </Box>
    </Container>
  )
}

export default AdminPrivateRoute
